export default "__VITE_ASSET__ieJRaGpE__"